export const NAVBAR_WIDTH = 94;
export const EXPANDED_NAVBAR_WIDTH = 314;
export const NAVBAR_LOGO_WIDTH = 32;
export const EXPANDED_NAVBAR_LOGO_WIDTH = 196;

export const SIZES = {
	NAVBAR_WIDTH,
	EXPANDED_NAVBAR_WIDTH,
	NAVBAR_LOGO_WIDTH,
	EXPANDED_NAVBAR_LOGO_WIDTH,
};
